export const create = {
  createSuccessfully: 'Create new machine successfully!',
}
